import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { IconButton, InputAdornment } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const UiSelectMultiType = (props) => {
  const {
    label,
    value,
    name,
    type,
    error,
    inputStartIcon,
    enableAdornment,
    startadornmenttext,
    placeholder,
    multiline,
    maxRows,
    minRows,
    onInput,
    onChange,
    readonly,
    helperText,
    form,
  } = props;

  React.useEffect(() => {
    form?.change(name, value);
  }, [value]);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl sx={{ mb: 2 }} variant="outlined" fullWidth error={error}>
        <InputLabel className="df-select-label">{props.label}</InputLabel>
        <Select
          {...props}
          labelId="demo-simple-select-label"
          className="df-input-field"
          value={value}
          label={props.label}
          IconComponent={ExpandMoreIcon}
          inputProps={{
            onChange: (event) => {
              const input = event.target.value;
            },
          }}
          startAdornment={
            enableAdornment && (
              <InputAdornment position="start" className="df-select-adornment">
                <IconButton aria-label="Edit input" edge="end">
                  {inputStartIcon && <img src={inputStartIcon} />}
                  {startadornmenttext && startadornmenttext}
                </IconButton>
              </InputAdornment>
            )
          }
        >
          {props.children}
        </Select>
      </FormControl>
    </Box>
  );
};

export default function UiSelectM(props) {
  const {
    label,
    value,
    name,
    type,
    error,
    inputStartIcon,
    enableAdornment,
    startadornmenttext,
    placeholder,
    multiline,
    maxRows,
    minRows,
    onInput,
    onChange,
    readonly,
    helperText,
    form,
  } = props;

  useEffect(() => {
    form?.change(name, value);
  }, [value]);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl sx={{ mb: 2 }} variant="outlined" fullWidth error={error}>
        <InputLabel className="df-select-label">{props.label}</InputLabel>
        <Select
          {...props}
          labelId="demo-simple-select-label"
          className="df-input-field"
          value={value}
          label={props.label}
          IconComponent={ExpandMoreIcon}
          inputProps={{
            onChange: (event) => {
              const input = event.target.value;
            },
          }}
          startAdornment={
            enableAdornment && (
              <InputAdornment position="start" className="df-select-adornment">
                <IconButton aria-label="Edit input" edge="end">
                  {inputStartIcon && <img src={inputStartIcon} />}
                  {startadornmenttext && startadornmenttext}
                </IconButton>
              </InputAdornment>
            )
          }
        >
          {props.children}
        </Select>
      </FormControl>
    </Box>
  );
}
